function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRideStepMarker({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "183 373 48 48",
    style: {
      enableBackground: "new 183 373 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e8d7aa"
    },
    d: "M183 373h48v48h-48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M220.734 409.188v-.509a1.525 1.525 0 0 0-1.017-1.428v-.606a1.522 1.522 0 0 0-1.017-1.432v-7.817a1.523 1.523 0 0 0 1.017-1.432v-.897l.927-1.854 1.467-1.467a.508.508 0 0 0-.094-.794l-14.751-9.002a.51.51 0 0 0-.53 0l-14.751 9.002a.508.508 0 0 0-.095.793l1.467 1.467.927 1.854v.897a1.522 1.522 0 0 0 1.017 1.432v7.817a1.523 1.523 0 0 0-1.017 1.432v.606a1.525 1.525 0 0 0-1.017 1.428v.509a1.528 1.528 0 0 0-1.526 1.526v1.017c0 .281.228.509.508.509h29.502a.509.509 0 0 0 .509-.508v-1.017a1.528 1.528 0 0 0-1.526-1.526zm-2.035-13.225a.51.51 0 0 1-.509.509h-3.052a.51.51 0 0 1-.509-.509v-.509h4.069v.509zm-24.849-3.696-.785-.785L207 382.979l13.934 8.503-.785.785-12.883-7.928a.507.507 0 0 0-.533 0l-12.883 7.928zm15.185-3.171a2.035 2.035 0 1 1-4.07 0 2.035 2.035 0 0 1 4.07 0zm-13.928 5.341-.509-1.017h24.804l-.509 1.017h-23.786zm18.506 1.017v.509a.51.51 0 0 1-.509.509h-3.052a.51.51 0 0 1-.509-.509v-.509h4.07zm-9.156 0v.509a.51.51 0 0 1-.509.509h-3.052a.51.51 0 0 1-.509-.509v-.509h4.07zm-5.087 0v.509a.51.51 0 0 1-.509.509h-3.052a.51.51 0 0 1-.509-.509v-.509h4.07zm0 11.7h-4.069v-.509a.51.51 0 0 1 .509-.509h3.052a.51.51 0 0 1 .509.509v.509zm0-1.941v-7.817a1.53 1.53 0 0 0 .509-.303c.148.133.321.236.509.303v7.817a1.53 1.53 0 0 0-.509.303 1.497 1.497 0 0 0-.509-.303zm5.087 1.941h-4.069v-.509a.51.51 0 0 1 .509-.509h3.052a.51.51 0 0 1 .509.509v.509zm4.069-.509v.509h-3.052v-.509a1.522 1.522 0 0 0-1.017-1.432v-7.817a1.523 1.523 0 0 0 1.017-1.432v-.509h3.052v.509a1.522 1.522 0 0 0 1.017 1.432v7.817a1.522 1.522 0 0 0-1.017 1.432zm5.087.509h-4.069v-.509a.51.51 0 0 1 .509-.509h3.052a.51.51 0 0 1 .509.509v.509zm0-1.941v-7.817a1.53 1.53 0 0 0 .509-.303c.148.133.321.236.509.303v7.817a1.53 1.53 0 0 0-.509.303 1.517 1.517 0 0 0-.509-.303zm5.086 1.941h-4.069v-.509a.51.51 0 0 1 .509-.509h3.052a.51.51 0 0 1 .509.509v.509z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#fff"
    },
    cx: 207,
    cy: 389.096,
    r: 1.017
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRideStepMarker);
export default __webpack_public_path__ + "static/media/ride-step-marker.14a6a71347b47945c3f34711b3734f58.svg";
export { ForwardRef as ReactComponent };